import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { SalonProvider } from './contexts/SalonContext'
import SelectBranchGate from './components/SelectBranchGate'
import DemoBanner from './components/DemoBanner'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <SalonProvider>
        <DemoBanner />
        <App />
        <SelectBranchGate />
      </SalonProvider>
    </AuthProvider>
  </React.StrictMode>,
)












